import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-par-token-screen',
    templateUrl: './par-token-screen.component.html',
    styleUrls: ['./par-token-screen.component.scss'],
    standalone: false
})
export class ParTokenScreenComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
